import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tappable } from '@vectord/components';
import cogoToast from 'cogo-toast';
import classNames from 'classnames';

import {
  batchSequenceSelector,
  learnerEmailsSelector,
  moduleRepeatSelector,
  pastClassesStatusSelector,
  resetEditCrashCourseBatch,
  selectedSuperBatchSelector,
  upcomingClassesStatusSelector,
  useAssociateMenteeToBatchMutation,
} from 'features/classCreation';
import GlobalLoader from 'components/GlobalLoader';
import styles from './AddLearnersButton.module.scss';

function AddLearnersButton() {
  const dispatch = useDispatch();
  const superBatch = useSelector(selectedSuperBatchSelector);
  const learnerEmails = useSelector(learnerEmailsSelector);
  const pastClassesStatus = useSelector(pastClassesStatusSelector);
  const upcomingClassesStatus = useSelector(upcomingClassesStatusSelector);
  const batchSequence = useSelector(batchSequenceSelector);
  const moduleRepeat = useSelector(moduleRepeatSelector);

  const [addLearners, { isSuccess, error, isLoading: isAdding }] =
    useAssociateMenteeToBatchMutation();

  const handleOnClick = useCallback(() => {
    let completedClassesStatus = pastClassesStatus;
    if (pastClassesStatus === 'undefined') completedClassesStatus = undefined;

    addLearners({
      superBatchId: superBatch.id,
      emails: learnerEmails,
      completedClassesStatus,
      upcomingClassesStatus,
      sequence: batchSequence,
      moduleRepeat,
    });
  }, [
    addLearners,
    learnerEmails,
    pastClassesStatus,
    superBatch.id,
    upcomingClassesStatus,
    batchSequence,
    moduleRepeat,
  ]);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success(
        'Changes updated successfully! Learners are added to the Super Batch'
      );
      dispatch(resetEditCrashCourseBatch());
    }
  }, [dispatch, isSuccess]);

  useEffect(() => {
    if (error) {
      cogoToast.error(
        error.data?.message || 'Something went wrong! Try again later.'
      );
    }
  }, [error]);

  return (
    <>
      <GlobalLoader isVisible={isAdding} />
      <Tappable
        onClick={handleOnClick}
        className={classNames('btn btn-primary', styles.root)}
        disabled={isAdding}
      >
        Confirm
      </Tappable>
    </>
  );
}

export default AddLearnersButton;
